import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/residential/pro/pro-background-1-1920x1280.webp")